<template>
  <v-row>
    <v-col cols="12" sm="6" md="3">
      <v-hover v-slot="{ hover }">
        <v-card 
          class="pa-6 rounded-xl transition-swing" 
          :elevation="hover ? 8 : 4"
          :class="{ 'transform-scale-105': hover }"
        >
          <div class="d-flex align-center justify-space-between">
            <div>
              <div class="text-caption text--secondary mb-1 font-weight-medium">TOTAL REGISTROS</div>
              <div class="text-h3 font-weight-bold primary--text">{{ total }}</div>
              <div class="text-caption text--secondary mt-1">
                <v-icon small color="success" class="mr-1">mdi-trending-up</v-icon>
                Todos los tiempos
              </div>
            </div>
            <v-avatar size="56" color="primary" class="elevation-2">
              <v-icon size="32" color="white">mdi-account-group</v-icon>
            </v-avatar>
          </div>
        </v-card>
      </v-hover>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-hover v-slot="{ hover }">
        <v-card 
          class="pa-6 rounded-xl transition-swing" 
          :elevation="hover ? 8 : 4"
          :class="{ 'transform-scale-105': hover }"
        >
          <div class="d-flex align-center justify-space-between">
            <div>
              <div class="text-caption text--secondary mb-1 font-weight-medium">DENTRO DEL PREDIO</div>
              <div class="text-h3 font-weight-bold success--text">{{ activos }}</div>
              <div class="text-caption text--secondary mt-1">
                <v-icon small color="success" class="mr-1">mdi-account-check</v-icon>
                Activos ahora
              </div>
            </div>
            <v-avatar size="56" color="success" class="elevation-2">
              <v-icon size="32" color="white">mdi-door-open</v-icon>
            </v-avatar>
          </div>
        </v-card>
      </v-hover>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-hover v-slot="{ hover }">
        <v-card 
          class="pa-6 rounded-xl transition-swing" 
          :elevation="hover ? 8 : 4"
          :class="{ 'transform-scale-105': hover }"
        >
          <div class="d-flex align-center justify-space-between">
            <div>
              <div class="text-caption text--secondary mb-1 font-weight-medium">CON SALIDA</div>
              <div class="text-h3 font-weight-bold info--text">{{ conSalida }}</div>
              <div class="text-caption text--secondary mt-1">
                <v-icon small color="info" class="mr-1">mdi-exit-run</v-icon>
                Registros completos
              </div>
            </div>
            <v-avatar size="56" color="info" class="elevation-2">
              <v-icon size="32" color="white">mdi-logout</v-icon>
            </v-avatar>
          </div>
        </v-card>
      </v-hover>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-hover v-slot="{ hover }">
        <v-card 
          class="pa-6 rounded-xl transition-swing" 
          :elevation="hover ? 8 : 4"
          :class="{ 'transform-scale-105': hover }"
        >
          <div class="d-flex align-center justify-space-between">
            <div>
              <div class="text-caption text--secondary mb-1 font-weight-medium">ENTRADAS HOY</div>
              <div class="text-h3 font-weight-bold orange--text">{{ hoy }}</div>
              <div class="text-caption text--secondary mt-1">
                <v-icon small color="orange" class="mr-1">mdi-calendar-today</v-icon>
                Día actual
              </div>
            </div>
            <v-avatar size="56" color="orange" class="elevation-2">
              <v-icon size="32" color="white">mdi-calendar-clock</v-icon>
            </v-avatar>
          </div>
        </v-card>
      </v-hover>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'StatsCards',
  props: {
    total: { type: Number, default: 0 },
    activos: { type: Number, default: 0 },
    conSalida: { type: Number, default: 0 },
    hoy: { type: Number, default: 0 },
  },
};
</script>

<style scoped></style>
